import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  // react-snap pre-rendered this page — hydrate instead of re-render
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
